// extracted by mini-css-extract-plugin
export default {"maxContentWrapper":"mine_maxContentWrapper__uRKB+","warpper":"mine_warpper__fVZ1W","rightWarpper":"mine_rightWarpper__8R7bT"};